import { Component, OnDestroy, OnInit } from '@angular/core';
import { AuthService } from '@app/service/auth.service';
import { environment } from '../../../environments/environment';  
declare var $,App,PerfectScrollbar;
@Component({
  selector: 'app-content-layout',
  templateUrl: './content-layout.component.html',
  styleUrls: ['./content-layout.component.scss']
})
export class ContentLayoutComponent implements OnInit {

  token;
  constructor(private api: AuthService) 
  { 
    if(localStorage.getItem(environment.tokenKey))
    {
      // this.token = JSON.parse(atob((localStorage.getItem(environment.tokenKey)).split('.')[1])).token
      this.api.getUserData({}).subscribe((res:any)=>{
        if(res.success){
          this.token = res.data
        }else{

        }
      })
    }    
  }

  ngOnInit(): void 
  {
    setTimeout(() => 
    {
      jqueryFns()
    }, 200)
  }

  setActive(i)
  {
    var menu = document.getElementsByClassName('menu');

    // console.log(menu);
    

    for (let index = 0; index < menu.length; index++) 
    {
      if(document.getElementById("menu"+index))
      {
        document.getElementById("menu"+index).classList.remove('active');
      }
    }

    if(document.getElementById("menu"+i))
    {
      document.getElementById("menu"+i).classList.add('active');
    }
  }

}

function jqueryFns()
{
  $(document).ready(function() 
  {
    // Initialize multiple plugins
    App.init();
    // Initialize scrollbar
    $('.mt-container').each(function(){ const ps = new PerfectScrollbar($(this)[0]); });
});
}
